import LandingPageGroup from "./group";

export { LandingPageGroup }
